/**
 * Check if the current "nodejs env" is a test env (Vitest)
 * @returns true if the current nodejs env is vitest
 */
export function isRunningInTest() {
  return import.meta.env.VITEST === 'true'
}
